/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateOfferingDto,
  DeletedResponseDto,
  OfferingListResponseDto,
  OfferingResponseDto,
  ProductTypesResponseDto,
  UpdateOfferingDto,
  V1ProductControllerGetByVariantIdsParams,
  V1ProductControllerListProductsParams,
  V1ProductControllerSearchProductsParams,
  VectorSearchProductResponseDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Lists products sorted by most recent (creation date descending). For initial product picker display.
 * @summary List products for picker
 */
export const v1ProductControllerListProducts = (
  orgId: string,
  clientId: string,
  params?: V1ProductControllerListProductsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<VectorSearchProductResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getV1ProductControllerListProductsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: V1ProductControllerListProductsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/products`,
    ...(params ? [params] : []),
  ] as const;
};

export const getV1ProductControllerListProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: V1ProductControllerListProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListProducts>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getV1ProductControllerListProductsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductControllerListProducts>>> = ({
    signal,
  }) => v1ProductControllerListProducts(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type V1ProductControllerListProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerListProducts>>
>;
export type V1ProductControllerListProductsQueryError = unknown;

export function useV1ProductControllerListProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: undefined | V1ProductControllerListProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerListProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerListProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: V1ProductControllerListProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerListProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerListProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: V1ProductControllerListProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListProducts>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List products for picker
 */

export function useV1ProductControllerListProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerListProducts>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: V1ProductControllerListProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListProducts>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getV1ProductControllerListProductsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all unique product types for the client (e.g., "Gift Card", "Apparel")
 * @summary Get distinct product types
 */
export const v1ProductControllerGetProductTypes = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ProductTypesResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products/types`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getV1ProductControllerGetProductTypesQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/products/types`] as const;
};

export const getV1ProductControllerGetProductTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getV1ProductControllerGetProductTypesQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>> = ({
    signal,
  }) => v1ProductControllerGetProductTypes(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type V1ProductControllerGetProductTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>
>;
export type V1ProductControllerGetProductTypesQueryError = unknown;

export function useV1ProductControllerGetProductTypes<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerGetProductTypes<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerGetProductTypes<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get distinct product types
 */

export function useV1ProductControllerGetProductTypes<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetProductTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getV1ProductControllerGetProductTypesQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Simple text search across product titles, variant titles, and SKUs. For manual product selection in UI.
 * @summary Search products by text
 */
export const v1ProductControllerSearchProducts = (
  orgId: string,
  clientId: string,
  params: V1ProductControllerSearchProductsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<VectorSearchProductResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products/search`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getV1ProductControllerSearchProductsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: V1ProductControllerSearchProductsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/products/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getV1ProductControllerSearchProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerSearchProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getV1ProductControllerSearchProductsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>> = ({
    signal,
  }) => v1ProductControllerSearchProducts(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type V1ProductControllerSearchProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>
>;
export type V1ProductControllerSearchProductsQueryError = void;

export function useV1ProductControllerSearchProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerSearchProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerSearchProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerSearchProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerSearchProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerSearchProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search products by text
 */

export function useV1ProductControllerSearchProducts<
  TData = Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerSearchProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerSearchProducts>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getV1ProductControllerSearchProductsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch specific product variants by their IDs. Used to hydrate saved product feed selections.
 * @summary Get products by variant IDs
 */
export const v1ProductControllerGetByVariantIds = (
  orgId: string,
  clientId: string,
  params: V1ProductControllerGetByVariantIdsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<VectorSearchProductResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products/by-variant-ids`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getV1ProductControllerGetByVariantIdsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: V1ProductControllerGetByVariantIdsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/products/by-variant-ids`,
    ...(params ? [params] : []),
  ] as const;
};

export const getV1ProductControllerGetByVariantIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerGetByVariantIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getV1ProductControllerGetByVariantIdsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>> = ({
    signal,
  }) => v1ProductControllerGetByVariantIds(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type V1ProductControllerGetByVariantIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>
>;
export type V1ProductControllerGetByVariantIdsQueryError = unknown;

export function useV1ProductControllerGetByVariantIds<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerGetByVariantIdsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerGetByVariantIds<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerGetByVariantIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerGetByVariantIds<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerGetByVariantIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get products by variant IDs
 */

export function useV1ProductControllerGetByVariantIds<
  TData = Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: V1ProductControllerGetByVariantIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerGetByVariantIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getV1ProductControllerGetByVariantIdsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lists manually-entered and auto-extracted offerings (plans, subscriptions, services) for this client.
 * @summary List offerings
 */
export const v1ProductControllerListOfferings = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OfferingListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products/offerings`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getV1ProductControllerListOfferingsQueryKey = (orgId?: string, clientId?: string) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/products/offerings`] as const;
};

export const getV1ProductControllerListOfferingsQueryOptions = <
  TData = Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListOfferings>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getV1ProductControllerListOfferingsQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductControllerListOfferings>>> = ({
    signal,
  }) => v1ProductControllerListOfferings(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type V1ProductControllerListOfferingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerListOfferings>>
>;
export type V1ProductControllerListOfferingsQueryError = unknown;

export function useV1ProductControllerListOfferings<
  TData = Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListOfferings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerListOfferings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerListOfferings<
  TData = Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListOfferings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
          TError,
          Awaited<ReturnType<typeof v1ProductControllerListOfferings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useV1ProductControllerListOfferings<
  TData = Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListOfferings>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List offerings
 */

export function useV1ProductControllerListOfferings<
  TData = Awaited<ReturnType<typeof v1ProductControllerListOfferings>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof v1ProductControllerListOfferings>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getV1ProductControllerListOfferingsQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a manual offering (plan/subscription/service) so it is merchandisable by the email agent.
 * @summary Create an offering
 */
export const v1ProductControllerCreateOffering = (
  orgId: string,
  clientId: string,
  createOfferingDto: CreateOfferingDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OfferingResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products/offerings`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createOfferingDto,
      signal,
    },
    options
  );
};

export const getV1ProductControllerCreateOfferingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof v1ProductControllerCreateOffering>>,
    TError,
    { orgId: string; clientId: string; data: CreateOfferingDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof v1ProductControllerCreateOffering>>,
  TError,
  { orgId: string; clientId: string; data: CreateOfferingDto },
  TContext
> => {
  const mutationKey = ['v1ProductControllerCreateOffering'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof v1ProductControllerCreateOffering>>,
    { orgId: string; clientId: string; data: CreateOfferingDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return v1ProductControllerCreateOffering(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type V1ProductControllerCreateOfferingMutationResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerCreateOffering>>
>;
export type V1ProductControllerCreateOfferingMutationBody = CreateOfferingDto;
export type V1ProductControllerCreateOfferingMutationError = unknown;

/**
 * @summary Create an offering
 */
export const useV1ProductControllerCreateOffering = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof v1ProductControllerCreateOffering>>,
      TError,
      { orgId: string; clientId: string; data: CreateOfferingDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof v1ProductControllerCreateOffering>>,
  TError,
  { orgId: string; clientId: string; data: CreateOfferingDto },
  TContext
> => {
  const mutationOptions = getV1ProductControllerCreateOfferingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Full replace of an offering; removed price points are pruned. Fields omitted fall back to current values.
 * @summary Update an offering
 */
export const v1ProductControllerUpdateOffering = (
  orgId: string,
  clientId: string,
  productId: string,
  updateOfferingDto: UpdateOfferingDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<OfferingResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products/offerings/${productId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateOfferingDto,
    },
    options
  );
};

export const getV1ProductControllerUpdateOfferingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof v1ProductControllerUpdateOffering>>,
    TError,
    { orgId: string; clientId: string; productId: string; data: UpdateOfferingDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof v1ProductControllerUpdateOffering>>,
  TError,
  { orgId: string; clientId: string; productId: string; data: UpdateOfferingDto },
  TContext
> => {
  const mutationKey = ['v1ProductControllerUpdateOffering'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof v1ProductControllerUpdateOffering>>,
    { orgId: string; clientId: string; productId: string; data: UpdateOfferingDto }
  > = (props) => {
    const { orgId, clientId, productId, data } = props ?? {};

    return v1ProductControllerUpdateOffering(orgId, clientId, productId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type V1ProductControllerUpdateOfferingMutationResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerUpdateOffering>>
>;
export type V1ProductControllerUpdateOfferingMutationBody = UpdateOfferingDto;
export type V1ProductControllerUpdateOfferingMutationError = unknown;

/**
 * @summary Update an offering
 */
export const useV1ProductControllerUpdateOffering = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof v1ProductControllerUpdateOffering>>,
      TError,
      { orgId: string; clientId: string; productId: string; data: UpdateOfferingDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof v1ProductControllerUpdateOffering>>,
  TError,
  { orgId: string; clientId: string; productId: string; data: UpdateOfferingDto },
  TContext
> => {
  const mutationOptions = getV1ProductControllerUpdateOfferingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-deletes a manual/scraped offering.
 * @summary Delete an offering
 */
export const v1ProductControllerDeleteOffering = (
  orgId: string,
  clientId: string,
  productId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeletedResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/products/offerings/${productId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getV1ProductControllerDeleteOfferingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof v1ProductControllerDeleteOffering>>,
    TError,
    { orgId: string; clientId: string; productId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof v1ProductControllerDeleteOffering>>,
  TError,
  { orgId: string; clientId: string; productId: string },
  TContext
> => {
  const mutationKey = ['v1ProductControllerDeleteOffering'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof v1ProductControllerDeleteOffering>>,
    { orgId: string; clientId: string; productId: string }
  > = (props) => {
    const { orgId, clientId, productId } = props ?? {};

    return v1ProductControllerDeleteOffering(orgId, clientId, productId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type V1ProductControllerDeleteOfferingMutationResult = NonNullable<
  Awaited<ReturnType<typeof v1ProductControllerDeleteOffering>>
>;

export type V1ProductControllerDeleteOfferingMutationError = unknown;

/**
 * @summary Delete an offering
 */
export const useV1ProductControllerDeleteOffering = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof v1ProductControllerDeleteOffering>>,
      TError,
      { orgId: string; clientId: string; productId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof v1ProductControllerDeleteOffering>>,
  TError,
  { orgId: string; clientId: string; productId: string },
  TContext
> => {
  const mutationOptions = getV1ProductControllerDeleteOfferingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
